import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataDeductionTypesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataDeductionTypesUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataDeductionTypesDTO) {
    return this.repository.getDeductionTypes(params);
  }
}
